import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2, Loader2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { listBlog, deletePost } from "@/lib/adminCmsApi";
import AdminShell from "@/components/admin/AdminShell";

export default function AdminBlog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { setPosts(await listBlog()); }
    catch (e) { toast.error("Load failed"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (p) => {
    if (!window.confirm(`Delete post "${p.title}"?`)) return;
    try { await deletePost(p.id); toast.success("Deleted"); load(); }
    catch (e) { toast.error("Delete failed"); }
  };

  return (
    <AdminShell title="Blog">
      <div className="mb-6 flex items-center justify-between">
        <p className="text-sm text-ags-text-muted">Write articles for the public blog. Each post supports cover image + rich text body.</p>
        <Link to="/admin/blog/new" data-testid="new-post-btn"
              className="inline-flex items-center gap-2 bg-[#0E2A57] text-white hover:bg-[#050B14] px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.22em]">
          <Plus size={14} /> New Post
        </Link>
      </div>

      <div className="bg-white border border-[#0E2A57]/15">
        {loading ? <div className="p-12 flex items-center justify-center"><Loader2 className="animate-spin" /></div> :
         posts.length === 0 ? <div className="p-12 text-center font-mono text-[11px] uppercase tracking-[0.22em] text-ags-text-muted">No posts yet — click New Post</div> :
         <ul className="divide-y divide-ags-hairline">
           {posts.map((p) => (
             <li key={p.id} data-testid={`post-row-${p.slug}`} className="px-6 py-4 flex items-center gap-4 hover:bg-ags-cream">
               {p.cover_image_url ? <img src={p.cover_image_url} alt="" className="w-20 h-14 object-cover border border-ags-hairline" /> :
                                    <div className="w-20 h-14 bg-ags-cream" />}
               <div className="flex-1 min-w-0">
                 <div className="font-heading font-bold text-ags-ink tracking-[-0.02em]">{p.title}</div>
                 <div className="font-mono text-xs text-ags-text-muted mt-1">/{p.slug} · {p.status} · {p.published_at?.slice(0,10)}</div>
                 {p.excerpt && <div className="text-sm text-ags-text-muted mt-1 line-clamp-1">{p.excerpt}</div>}
               </div>
               <a href={`/blog/${p.slug}`} target="_blank" rel="noopener noreferrer" className="text-ags-text-muted hover:text-[#0E2A57] p-2"><ExternalLink size={16} /></a>
               <Link to={`/admin/blog/${p.id}`} className="inline-flex items-center gap-2 bg-[#0E2A57] text-white hover:bg-[#050B14] px-3 py-2 font-mono text-[10px] uppercase tracking-[0.22em]"><Pencil size={12} /> Edit</Link>
               <button onClick={() => remove(p)} className="text-red-600 hover:bg-red-50 p-2"><Trash2 size={16} /></button>
             </li>
           ))}
         </ul>
        }
      </div>
    </AdminShell>
  );
}
